import { useMemo } from 'react';

import { useFlashOffers } from 'providers/FlashOffersProvider';

const MILLISECONDS_PER_SECOND = 1000;
const MILLISECONDS_PER_MINUTE = MILLISECONDS_PER_SECOND * 60;
const MILLISECONDS_PER_HOUR = MILLISECONDS_PER_MINUTE * 60;

const EXPIRED_STATE = { hours: 0, minutes: 0, seconds: 0, isExpired: true };

function calcTimeLeft(targetDate, now) {
  const diff = Math.max(0, targetDate - now);

  const hours = Math.floor(diff / MILLISECONDS_PER_HOUR);
  const minutes = Math.floor(
    (diff % MILLISECONDS_PER_HOUR) / MILLISECONDS_PER_MINUTE
  );
  const seconds = Math.floor(
    (diff % MILLISECONDS_PER_MINUTE) / MILLISECONDS_PER_SECOND
  );

  return {
    hours,
    minutes,
    seconds,
    isExpired: diff === 0,
  };
}

function useCountdown(targetDate) {
  const { tick } = useFlashOffers();
  const targetTime = targetDate?.getTime?.() || 0;

  const timeLeft = useMemo(() => {
    if (!targetTime) {
      return EXPIRED_STATE;
    }

    return calcTimeLeft(new Date(targetTime), new Date(tick));
  }, [targetTime, tick]);

  return timeLeft;
}

export default useCountdown;
